<div [class.oiq-ui-dialog]="dialogRef">
  @if (dialogRef) {
    <header>
      <div class="__title">
        <div>
          <h2>Attachment Files for Funding</h2>
          <p>Upload your document for optical character recognition (OCR).</p>
        </div>
        <button
          (click)="dialogRef.close(null)"
          class="oiq-button oiq-button--link __close"
          type="button">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
    </header>
  }
  <main class="oiq-application-add-main flex w-full flex-row gap-0 bg-[#FBFCFD]" style="padding: 0">
    <form [formGroup]="formRef" autocomplete="off">
      <section>
        <div class="flex h-full flex-grow flex-col gap-4 overflow-y-auto">
          @if (mode() == 'application') {
            <!--Step 1: Application info & Documents-->
            <div class="panel-wrapper space-y-2">
              <h3 class="text-md font-medium">Application Info</h3>
              <section class="grid grid-cols-3 items-start gap-6 divide-x align-top">
                <div class="col-span-3 grid grid-cols-3 gap-4 lg:col-span-2">
                  <oiq-form-dropdown
                    class="white-label-dropdown oiq-form-control__flat oiq-form-control__text-primary oiq-form-control__inline col-span-2"
                    label="White Label:"
                    formControlName="whiteLabelId"
                    placeholder="No White Label Selected"
                    [searchable]="false"
                    [options]="store.whiteLabels$ | async"
                    [configuration]="{
                      text: 'name',
                      id: 'id'
                    }">
                  </oiq-form-dropdown>

                  <oiq-form-checkbox
                    type="toggle"
                    class="high-priority-checkbox col-span-1 my-auto ml-auto flex-grow-0"
                    label="High Priority"
                    formControlName="urgent"></oiq-form-checkbox>

                  <oiq-form-value
                    label="Client"
                    placeholder="Select Client"
                    class="icon-base col-span-2 block w-full"
                    formControlName="clientName"
                    [suffixIcon]="formRef.get('clientName').value ? '' : 'search'"
                    [canClear]="true"
                    (click)="openClientDialog('search')"
                    (event)="onClientEvent($event)"></oiq-form-value>

                  <oiq-form-dropdown
                    class="col-span-1 flex-grow-0"
                    label="Type"
                    formControlName="type"
                    [itemsWidth]="240"
                    [searchable]="false"
                    [virtual]="false"
                    [options]="store.tenantApplicationTypes$ | async"
                    [configuration]="{
                      text: 'name',
                      id: 'value'
                    }"></oiq-form-dropdown>

                  <div class="col-span-3 grid grid-cols-3 gap-4">
                    @let _whiteLabelId = whiteLabelId();
                    @let _isoId = formRef.isoId$ | async;
                    <div [class.col-span-2]="_isoId" [class.col-span-3]="!_isoId">
                      <!-- new row -->
                      <oiq-iso-search
                        class="w-full"
                        label="Referring ISO"
                        [whiteLabelId]="_whiteLabelId"
                        formControlName="isoId"
                        [showRequired]="true">
                        @if (!_whiteLabelId) {
                          <div>
                            <small
                              >Please select a White Label in order to choose a Referring ISO</small
                            >
                          </div>
                        }
                      </oiq-iso-search>
                    </div>

                    @if (_isoId) {
                      <oiq-iso-sales-rep-select
                        formControlName="isoSalesRepresentativeId"
                        [isoId]="_isoId"></oiq-iso-sales-rep-select>
                    }
                  </div>
                </div>

                <div class="col-span-3 flex h-full flex-col gap-2 pl-6 lg:col-span-1">
                  <div class="flex flex-col gap-1 text-sm">
                    <div class="mb-1 text-sm text-gray-2">Notifications</div>
                    <oiq-form-checkbox
                      label="Email Notifications Enabled"
                      formControlName="sendEmailNotifications"></oiq-form-checkbox>
                    <oiq-form-checkbox
                      label="SMS Notifications Enabled"
                      formControlName="sendSmsNotifications"></oiq-form-checkbox>
                  </div>

                  <div class="mt-2">
                    <h3 class="mb-1 flex items-center justify-between text-sm text-gray-2">
                      <span class="flex-grow">Additional Recipients</span>
                      <button
                        type="button"
                        class="oiq-button oiq-button--primary--link flex-shrink-0 px-2 py-1"
                        (click)="formRef.addEmailRecipient('')">
                        <span class="ph ph-plus"></span>
                        Add New
                      </button>
                    </h3>
                    <div class="flex flex-col gap-4">
                      @for (
                        email of formRef.emailRecipients.controls;
                        track email.value;
                        let _idx = $index
                      ) {
                        <div class="flex items-start gap-2">
                          <oiq-form-input
                            [formControl]="email"
                            type="email"
                            placeholder="Email"
                            class="flex-grow"
                            phIcon="ph-envelope">
                            <ng-template #tplRight>
                              <button
                                type="button"
                                class="oiq-button oiq-button--link oiq-button--sm __action"
                                (click)="formRef.removeEmailRecipient(_idx)">
                                <span class="ph ph-trash"></span>
                              </button>
                            </ng-template>
                          </oiq-form-input>
                        </div>
                      }
                    </div>
                  </div>

                  <div>
                    <div class="mb-1 flex items-center justify-between">
                      <div class="text-sm text-gray-2">Operations Notes</div>
                      @if (showOperationsNotes()) {
                        <button
                          type="button"
                          class="oiq-button oiq-button--link z-10 flex items-center gap-1 px-2 py-1 text-[15px] text-[#8A8F9B]"
                          (click)="
                            showOperationsNotes.set(!showOperationsNotes());
                            formRef.controls.operationsNotes.setValue('')
                          ">
                          <span class="ph ph-trash"></span>
                          Delete
                        </button>
                      } @else {
                        <button
                          class="oiq-button oiq-button--primary--link px-2 py-1"
                          type="button"
                          (click)="showOperationsNotes.set(!showOperationsNotes())">
                          <span class="ph ph-plus"></span>
                          Add Notes
                        </button>
                      }
                    </div>

                    <!-- @if (!showOperationsNotes()) {
                      <button
                        class="oiq-button oiq-button--primary--link py-1 px-2"
                        type="button"
                        (click)="showOperationsNotes.set(!showOperationsNotes())">
                        <span class="ph ph-plus"></span>
                        Add Operations Notes
                      </button>
                    } -->

                    @if (showOperationsNotes()) {
                      <oiq-form-text
                        formControlName="operationsNotes"
                        [textRows]="6"
                        class="operations-notes-container w-full"></oiq-form-text>
                    }
                  </div>
                </div>
              </section>
            </div>
          }

          <!-- Files -->
          <oiq-ui-panel
            titleText="Files"
            [collapsable]="mode() == 'application'"
            [initialyCollapsed]="false"
            class="oiq-ui-panel__flat oiq-ui-panel__no-splitter shadow-top-md flex-shrink-0 rounded-none shadow-none">
            <ng-template #panelRight>
              @if (filesCount(); as _filesCount) {
                <span
                  class="inline-block flex-grow-0 rounded bg-primary-50 px-2 py-0.5 text-xs text-primary">
                  {{ _filesCount }}
                </span>
              }
            </ng-template>
            <div class="mb-4 flex items-center gap-2 rounded bg-gray-1 p-4">
              <div class="flex items-center gap-2 text-white">
                <span class="ph ph-warning text-2xl"></span>
              </div>
              <div class="ml-2 border-l border-l-gray-2 pl-4">
                <p class="text-xs font-thin text-gray-3">
                  At this stage You need to select
                  <b class="font-medium text-white">ONLY Credit Application Document.</b><br />OCR
                  for <b class="font-medium text-white">Bank Statements</b> is used in Underwriting
                </p>
              </div>
            </div>

            <oiq-attachments-upload
              class="block flex-grow"
              [filesTableColumns]="['fileName', 'actions']"
              [uploadUrl]="uploadUrl"
              (event)="handleAttachmentsEvents($event)"
              [canView]="true"
              [canSelect]="mode() == 'upload'"
              selectionMode="any"
              [selectMulti]="false"
              [showChildren]="false"
              [canRunOcr]="true"
              [layout]="dialogRef ? 'vertical-reverse' : 'horizontal'"
              [showFilesCount]="false">
            </oiq-attachments-upload>
          </oiq-ui-panel>

          @if (mode() == 'application') {
            <div class="flex flex-grow flex-col gap-4">
              <div class="mb-4 flex flex-row items-center justify-start gap-2">
                @if (!store.hasCreditReport()) {
                  <h3 class="text-base font-medium">Owners</h3>
                } @else {
                  <h3 class="text-base font-medium">Credit Check</h3>
                }
                <!--                @if (!store.hasCreditReport()) {-->
                <!--                  <aside class="flex items-center gap-2 justify-end">-->
                <!--                    <span class="text-gray-2 text-sm">Credit check not enabled</span>-->
                <!--                  </aside>-->
                <!--                }-->
              </div>
              @if (formRef.get('clientId').value) {
                <div formArrayName="creditCheckRequests" class="space-y-4 pb-4">
                  @if (ssnAlert.matches().length > 0) {
                    <oiq-ssn-alert (view)="ssnAlert.open()"></oiq-ssn-alert>
                  }
                  @if (store.hasCreditReport()) {
                    <p class="text-xs text-gray-2">Credit Check Participants</p>
                  }
                  @for (item of formRef.creditCheckRequests.controls; track item.contactId) {
                    <oiq-ui-panel
                      #creditCheckRef="OiqUiPanel"
                      class="credit-check-panel-item block shadow-none"
                      [class.bg-gray-6]="creditCheckRef.expanded"
                      [collapsable]="true"
                      [initialyCollapsed]="true"
                      [titleText]="item.get('firstName').value + ' ' + item.get('lastName').value"
                      [formGroup]="item">
                      <ng-template #panelRight>
                        <div class="flex items-center justify-start">
                          <div
                            class="primary-contact-select-wrapper flex items-center justify-center gap-1 rounded px-3 py-1 text-xs"
                            [class.primary-contact]="!!item.isPrimary">
                            <oiq-form-checkbox
                              type="radio"
                              label="Primary"
                              [value]="item.isPrimary"
                              class="primary-contact-checkbox rounded px-3 py-1"
                              [class.bg-primary-50]="item.isPrimary"
                              [class.bg-primary-5]="!item.isPrimary"
                              (click)="formRef.setPrimaryOwner(item)"></oiq-form-checkbox>
                          </div>
                          <div
                            class="flex flex-1 cursor-default items-center justify-between gap-2">
                            @if (store.hasCreditReport()) {
                              <oiq-form-checkbox
                                class="exclude-from-credit-check-checkbox"
                                [label]="
                                  'Exclude from credit check ' +
                                  (item.isExcluded ? 'and save contact info' : '')
                                "
                                formControlName="exclude"></oiq-form-checkbox>
                            } @else {
                              <div>&nbsp;</div>
                            }
                            <!-- Validation error message -->
                            @if (item.invalid) {
                              <div class="flex items-center gap-1 text-sm text-red-600">
                                <span class="material-icons text-sm text-red-600">error</span>
                                <span>Missing or invalid data.</span>
                              </div>
                            }
                          </div>
                        </div>
                      </ng-template>
                      <div class="mb-2 p-4">
                        <section class="credit-check-section">
                          <div class="mt-4 grid w-full grid-cols-2 gap-4">
                            <div>
                              <oiq-form-ssn
                                class="w-full"
                                label="Social Security Number"
                                formControlName="ssn"
                                [errorMap]="{
                                  required: 'Social Security Number is required'
                                }"></oiq-form-ssn>
                            </div>

                            <oiq-form-dob
                              label="Date of Birth"
                              formControlName="dob"
                              class="col-span-1"></oiq-form-dob>

                            @let _exclude = item.exclude$ | async;
                            <oiq-form-address
                              formControlName="address"
                              class="col-span-2"
                              layout="3row"
                              [showRequired]="!_exclude"
                              [required]="!_exclude"></oiq-form-address>
                          </div>
                        </section>
                      </div>
                    </oiq-ui-panel>
                  }
                </div>
              } @else {
                <p class="text-sm text-gray-2">
                  <button
                    class="oiq-button oiq-button--link p-0 underline hover:bg-transparent"
                    (click)="openClientDialog('search')">
                    <span class="font-normal text-gray-2">Select a client</span>
                  </button>
                  <span> to see the list of </span>
                  @if (store.hasCreditReport()) {
                    <span>participants</span>
                  } @else {
                    <span>owners</span>
                  }
                </p>
              }
            </div>
          }
        </div>

        <footer class="border-t border-t-gray-4 p-3">
          <div class="flex justify-end gap-4">
            <button class="oiq-button oiq-button--outline" (click)="onCancel()">Cancel</button>

            @if (mode() == 'application') {
              <button
                class="oiq-button oiq-button--primary--outline oiq-button--sm flex items-center gap-2"
                type="button"
                (click)="onDecline()">
                <span class="ph ph-x text-lg leading-none"></span>
                <span>Decline</span>
              </button>
            }

            @if (mode() == 'upload') {
              <button
                class="oiq-button oiq-button--primary--outline oiq-button--sm flex items-center gap-2"
                type="button"
                (click)="onManually()">
                <span>Create Manually</span>
              </button>

              <button
                class="oiq-button oiq-button--primary--solid oiq-button--sm flex items-center gap-2"
                type="button"
                [disabled]="attachments.selectionList().length == 0"
                (click)="onCreateUsingOcr()">
                <span>Create Using OCR</span>
              </button>
            }

            <!-- creditCheck not defined -->
            @if (mode() == 'application') {
              <button
                class="oiq-button oiq-button--primary--solid oiq-button--sm relative"
                [oiqUiLoader]="formRef.busy$ | async"
                type="button"
                [disabled]="formRef.busy$ | async"
                (click)="onCreateApplication()">
                <span class="ph ph-flag text-lg leading-none"></span>
                <span>{{
                  formRef.isSendToPreUnderwriting
                    ? 'Save & Send to Pre-Underwriting'
                    : 'Save & Send to Underwriting'
                }}</span>
              </button>
            }
          </div>
          <!--Step 1.1: Buttons-->
        </footer>
      </section>
      @if (attachments.viewingList().length > 0) {
        <aside class="overflow-y-auto">
          <oiq-image-preview-zoom
            class="block w-[30rem]"
            [attachments]="attachments.viewingList()"
            [enableZoom]="true"
            [showFileSize]="true"
            [canClose]="true"
            (close)="onCloseImagePreview()">
          </oiq-image-preview-zoom>
        </aside>
      }
    </form>
  </main>
</div>
